import React from "react";
import clap_logo from "../../assets/images/clap-logo.png";

const AppHeader = ({ children }: { children: JSX.Element }) => {
  return (
    <div
      style={{ zIndex: 1 }}
      className="h-12 fixed top-0 inset-x-0 bg-maastricht-blue flex justify-between items-center pl-4 pr-6"
    >
      <div className="flex items-center">
        <img src={clap_logo} alt="CLAP Logo" width={71} height={32} />
        <div className="text-white text-lg font-bold leading-8 ml-3">
          Royalty
        </div>
      </div>
      {children}
    </div>
  );
};

export default AppHeader;
